import { BookingDisplayModeEnum } from './types';

export const getClassNames = (mode: BookingDisplayModeEnum, isValidated?: boolean) => {
  if (mode === BookingDisplayModeEnum.Compact) {
    return `h-full flex-col ${typeof isValidated === 'boolean' ? 'py-0 pl-0 pr-1' : 'p-1'}`;
  }
  if (mode === BookingDisplayModeEnum.Regular) {
    return `h-10 ${typeof isValidated === 'boolean' ? 'py-0 px-0 pr-2' : 'py-0 px-2'} items-center`;
  }
  if (mode === BookingDisplayModeEnum.NoPadding) {
    return 'h-full flex-col';
  }
  return '';
};
